module.exports = __webpack_public_path__ + "static/media/click2.af2efb74.mp3";